module.exports = __webpack_public_path__ + "img/R05_EXIT 2.6a4c6f5c.jpg";